import { useSelector } from "react-redux";
import bossIllustration from "../../assets/Devenez votre propre patron.jpeg";
import feedCommunity from "../../assets/Nourrir votre communauté.jpg";
import revealTaste from "../../assets/Révélez les plats les plus savoureux de votre culture.jpg";
import { t } from "../../translations";
import "../styles/why-pani.css";

const WhyPani = () => {
  const lang = useSelector((state) => state.lang);

  return (
    <div style={{ margin: "100px 0 0 0" }}>
      <div>
        <h2
          style={{
            fontSize: "28px",
            alignItems: "center",
            color: "#FF114D",
            marginBottom: "40px"
          }}
        >
          {t("why_pani.title", lang)}
        </h2>
      </div>
      <div className="ContainerCardWhyPani">
        <div className="cardWhyPani">
          <div className="cardWhyPaniImgContainer">
            <img src={bossIllustration} alt="" />
          </div>
          <div className="cardWhyText">
            <h3 className="CardWhyH3">
              {t("why_pani.become_boss_title", lang)}
            </h3>
            <p className="cardWhyPaniPara">
              {t("why_pani.become_boss_description", lang)}
            </p>
          </div>
        </div>
        <div className="cardWhyPani">
          <div className="cardWhyPaniImgContainer">
            <img src={revealTaste} alt="" />
          </div>
          <div className="cardWhyText">
            <h3 className="CardWhyH3">
              {t("why_pani.showcase_culture_title", lang)}
            </h3>
            <p className="cardWhyPaniPara">
              {t("why_pani.showcase_culture_description", lang)}
            </p>
          </div>
        </div>
        <div className="cardWhyPani">
          <div className="cardWhyPaniImgContainer">
            <img src={feedCommunity} alt="" />
          </div>
          <div className="cardWhyText">
            <h3 className="CardWhyH3">
              {t("why_pani.feed_community_title", lang)}
            </h3>
            <p className="cardWhyPaniPara">
              {t("why_pani.feed_community_description", lang)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyPani;
